import React, { useState, useEffect } from "react";
import { db } from "../../firebase-config";
import { Link } from "react-router-dom";
import { ref, onValue } from "firebase/database";
import "./ViewAdminDetails.css";
// import "./ViewDetail.css";
import ChatNot from '../../components/Chat/ChatNot'; 
import '../../components/Chat/ChatNot.css';

function ViewAdminDetail() {
  const [users, setUser] = useState({});
  const [showDoctors, setShowDoctors] = useState(false);
  const [showPatients, setShowPatients] = useState(false);
  const [showTech, setShowTech] = useState(false);


  var adminName1 = localStorage.getItem("adminName");

  const handleDoctorClick = () => {
    setShowDoctors(!showDoctors);
    const button = document.getElementsByClassName('ShowButton');
    if (showDoctors) {
      button.setAttribute('data-state', 'hide');
    } else {
      button.setAttribute('data-state', 'show');
    }
  };

  const handlePatientsClick = () => {
    setShowPatients(!showPatients);
    const button = document.getElementsByClassName('ShowButton');
    if (showPatients) {
      button.setAttribute('data-state', 'hide');
    } else {
      button.setAttribute('data-state', 'show');
    }
  };

  const handleTechClick = () => {
    setShowTech(!showTech);
    const button = document.getElementsByClassName('ShowButton');
    if (showTech) {
      button.setAttribute('data-state', 'hide');
    } else {
      button.setAttribute('data-state', 'show');
    }
    };

  useEffect(() => {
    const users = ref(db, `superadmin/admins/${adminName1}`);
    onValue(users, (snapshot) => {
      if (snapshot.exists()) {
        setUser({ ...snapshot.val() });
      } else {
        setUser({});
      }
    });
  }, [adminName1]);

  // console.log("users", users);

  return (
    <>
      <div style={{ marginTop: "100px" }}>
        <h2 className="text-center adminName">{adminName1}</h2>
        <div className="container ">
          <div className="card-header">
            <strong>AdminName:</strong>
            <span className="admin-name">{adminName1}</span>
            <hr />

            <Link to={"/Admin/ViewAll"}>
              <button className="backbutton">Back</button>
            </Link>

            {/* CODE FOR DOCTORS DETAILS */}

            <div style={{ textAlign: 'center' }}>
              <button className="ShowButton" onClick={handleDoctorClick} data-state={showDoctors ? 'hide' : 'show'}>
                {showDoctors ? "Hide Doctors" : "Show Doctors"}
              </button>
              {showDoctors && (
                <>
                  <h5 className="text-center">DOCTORS</h5>
                  <br />
                  <table className="styled-table1">
                    <thead>
                      <tr>
                        <th className="th-head1" style={{ textAlign: "center" }}>
                          Name
                        </th>
                        <th className="th-head1" style={{ textAlign: "center" }}>
                          ID
                        </th>
                        <th className="th-head1" style={{ textAlign: "center" }}>
                          Role
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {React.Children.toArray(
                        users &&
                        users.doctors &&
                        Object.values(users.doctors).map((doctor) => {
                          return (
                            <>
                              <tr>
                                <td>{doctor.Name}</td>
                                <td>{doctor.ID}</td>
                                <td>Doctor</td>
                              </tr>
                            </>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                  <br />
                  <hr />
                </>
              )}
            </div>


            {/* CODE FOR PATIENTS DETAILS */}
            <div style={{ textAlign: 'center' }}>
              <button className="ShowButton" onClick={handlePatientsClick} data-state={showPatients ? 'hide' : 'show'}>
                {showPatients ? "Hide Patients" : "Show Patients"}
              </button>
              {showPatients && (
                <>
                  <h5 className="text-center">PATIENTS</h5>
                  <br />
                  <table className="styled-table1">
                    <thead>
                      <tr>
                        <th className="th-head1" style={{ textAlign: "center" }}>
                          Name
                        </th>
                        <th className="th-head1" style={{ textAlign: "center" }}>
                          Age
                        </th>
                        <th className="th-head1" style={{ textAlign: "center" }}>
                          ID
                        </th>
                        <th className="th-head1" style={{ textAlign: "center" }}>
                          Doctor Assigned
                        </th>
                        <th className="th-head1" style={{ textAlign: "center" }}>
                          Role
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {React.Children.toArray(
                        users &&
                        users.patients &&
                        Object.values(users.patients).map((patient) => {
                          return (
                            <>
                              <tr>
                                <td>{patient.FullName}</td>
                                <td>{patient.Age}</td>
                                <td>{patient.ID}</td>
                                <td style={{whiteSpace: "nowrap"}}>{patient.DoctorAssigned ? patient.DoctorAssigned.join(", ") : ""}</td>
                                <td>{patient.Role}</td>
                              </tr>
                            </>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                  <br />
                  <hr />
                </>
              )}
            </div>

            {/* CODE FOR TECHNICIANS DETAILS */}


            <div style={{ textAlign: 'center' }}>
              <button className="ShowButton" onClick={handleTechClick} data-state={showTech ? 'hide' : 'show'}>
                {showTech ? "Hide Technician" : "Show Technician"}
              </button>
              {showTech && (
                <>
                  <h5 className="text-center">TECHNICIANS</h5>

                  <br />
                  <table className="styled-table1">
                    <thead>
                      <tr>
                        <th className="th-head1" style={{ textAlign: "center" }}>
                          Name
                        </th>
                        <th className="th-head1" style={{ textAlign: "center" }}>
                          Email
                        </th>
                        <th className="th-head1" style={{ textAlign: "center" }}>
                          Role
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {React.Children.toArray(users &&
                        users.technicians &&
                        Object.values(users.technicians).map((technician) => {
                          return (
                            // console.log(technician),
                            (
                              <>

                                <tr>
                                  <td>{technician.Name}</td>
                                  <td>{technician.Email}</td>
                                  <td>{technician.Role}</td>
                                </tr>
                              </>
                            )
                          );
                        }))}
                    </tbody>
                  </table>
                </>
              )}
            </div>

            <br />
            <br />
            <div className="backbuttondetail">
              <Link to={"/Admin/ViewAll"}>
                <button className="backbutton2 ">Back</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div>
        <ChatNot />
      </div>
    </>

  );
}

export default ViewAdminDetail;
